import { render, staticRenderFns } from "./CategoriesHandler.vue?vue&type=template&id=a88f4238"
import script from "./CategoriesHandler.vue?vue&type=script&lang=js"
export * from "./CategoriesHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports